/**
 * Reusable Button Component
 */
export function Button({ 
  children, 
  onClick, 
  variant = 'secondary', 
  disabled = false,
  icon: Icon,
  className = '',
  ...props 
}) {
  const baseClasses = 'btn px-4 py-2 text-sm';
  const variantClasses = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {Icon && <Icon className="w-4 h-4 mr-2 inline-block" />}
      {children}
    </button>
  );
}
